var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3892 18.3477H20.5794C20.5794 18.3477 26.4419 24.0133 27.8745 25.5728C29.307 27.1323 27.2761 28.9275 25.8435 27.7489C24.4109 26.5702 18.3477 20.5793 18.3477 20.5793V19.3891L17.9014 18.9428C16.2649 20.4306 14.0333 21.3233 11.6528 21.3233C6.29692 21.3233 1.98242 17.0088 1.98242 11.6528C1.98242 6.29692 6.29692 1.98242 11.6528 1.98242C17.0088 1.98242 21.3233 6.29692 21.3233 11.6528C21.3233 14.0333 20.4307 16.2649 18.9429 17.9014L19.3892 18.3477ZM11.6371 19.4901C15.9742 19.4901 19.4901 15.9742 19.4901 11.6371C19.4901 7.30007 15.9742 3.78418 11.6371 3.78418C7.30007 3.78418 3.78418 7.30007 3.78418 11.6371C3.78418 15.9742 7.30007 19.4901 11.6371 19.4901Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.70e303cf.svg";
export { ForwardRef as ReactComponent };